// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AIFt7nJWh1ILj4D7iIA1 {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  width: 340px;
  padding: 24px;
  background: #FCFCFC;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.AIFt7nJWh1ILj4D7iIA1::-webkit-scrollbar {
  display: none;
}
@media only screen and (max-width: 1339px) {
  .AIFt7nJWh1ILj4D7iIA1 {
    width: 300px;
    padding: 16px;
  }
}
@media only screen and (max-width: 1259px) {
  .AIFt7nJWh1ILj4D7iIA1 {
    z-index: 14;
    width: 96px;
    align-items: center;
  }
}
@media only screen and (max-width: 767px) {
  .AIFt7nJWh1ILj4D7iIA1 {
    width: 100%;
    align-items: stretch;
  }
}
.dark-mode .AIFt7nJWh1ILj4D7iIA1 {
  background: #1A1D1F;
}

@media only screen and (max-width: 1259px) {
  .AIFt7nJWh1ILj4D7iIA1.paomKt1Wes4OfFNmBvEq {
    align-items: stretch;
    width: 300px;
    box-shadow: 4px 0 32px rgba(17, 19, 21, 0.05);
  }
  .AIFt7nJWh1ILj4D7iIA1.paomKt1Wes4OfFNmBvEq .PtD3LPT6aWiLC8AfJQU8,
  .AIFt7nJWh1ILj4D7iIA1.paomKt1Wes4OfFNmBvEq .ljGKLDmJ4fE0Ci6ZG4ez {
    width: 100%;
    font-size: 15px;
  }
  .AIFt7nJWh1ILj4D7iIA1.paomKt1Wes4OfFNmBvEq .PtD3LPT6aWiLC8AfJQU8 svg,
  .AIFt7nJWh1ILj4D7iIA1.paomKt1Wes4OfFNmBvEq .ljGKLDmJ4fE0Ci6ZG4ez svg {
    margin-right: 12px;
  }
  .AIFt7nJWh1ILj4D7iIA1.paomKt1Wes4OfFNmBvEq .ga1Zt896pLUjR0BQdrJw {
    display: block;
  }
  .AIFt7nJWh1ILj4D7iIA1.paomKt1Wes4OfFNmBvEq .gTZwnp_mAGASy0V65rSZ {
    position: absolute;
    top: 16px;
    right: 16px;
  }
  .AIFt7nJWh1ILj4D7iIA1.paomKt1Wes4OfFNmBvEq .gTZwnp_mAGASy0V65rSZ svg {
    fill: #1A1D1F;
  }
  .AIFt7nJWh1ILj4D7iIA1.paomKt1Wes4OfFNmBvEq .gTZwnp_mAGASy0V65rSZ svg:first-child {
    display: none;
  }
  .AIFt7nJWh1ILj4D7iIA1.paomKt1Wes4OfFNmBvEq .gTZwnp_mAGASy0V65rSZ svg:nth-child(2) {
    display: inline-block;
  }
}
@media only screen and (max-width: 767px) {
  .AIFt7nJWh1ILj4D7iIA1.paomKt1Wes4OfFNmBvEq {
    width: 100%;
  }
}

.Z6jXDuvIMbDGSO1NnHQV {
  display: block;
  width: 48px;
  margin-bottom: 48px;
}
@media only screen and (max-width: 1339px) {
  .Z6jXDuvIMbDGSO1NnHQV {
    margin-bottom: 24px;
  }
}
@media only screen and (max-width: 767px) {
  .Z6jXDuvIMbDGSO1NnHQV {
    margin-left: auto;
  }
}
.Z6jXDuvIMbDGSO1NnHQV img {
  width: 100%;
}

.MLBeAXKj4hfxhRkNxq2P {
  display: flex;
  flex-direction: column;
  margin-bottom: auto;
}

.PtD3LPT6aWiLC8AfJQU8,
.gjhxcI3Kt6h1okdIG1Z0 {
  margin-bottom: 8px;
}

.PtD3LPT6aWiLC8AfJQU8,
.ljGKLDmJ4fE0Ci6ZG4ez {
  display: flex;
  align-items: center;
  width: 100%;
  height: 48px;
  padding: 0 12px;
  border-radius: 12px;
  font-size: 15px;
  font-weight: 600;
  white-space: nowrap;
  color: #6F767E;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  transition: background 0.2s, box-shadow 0.2s, color 0.2s;
}
@media only screen and (max-width: 1259px) {
  .PtD3LPT6aWiLC8AfJQU8,
  .ljGKLDmJ4fE0Ci6ZG4ez {
    width: 48px;
    font-size: 0;
  }
}
@media only screen and (max-width: 767px) {
  .PtD3LPT6aWiLC8AfJQU8,
  .ljGKLDmJ4fE0Ci6ZG4ez {
    width: 100%;
    font-size: 15px;
  }
}
.PtD3LPT6aWiLC8AfJQU8 svg,
.ljGKLDmJ4fE0Ci6ZG4ez svg {
  margin-right: 12px;
  fill: #6F767E;
  transition: fill 0.2s;
}
@media only screen and (max-width: 1259px) {
  .PtD3LPT6aWiLC8AfJQU8 svg,
  .ljGKLDmJ4fE0Ci6ZG4ez svg {
    margin-right: 0;
  }
}
@media only screen and (max-width: 767px) {
  .PtD3LPT6aWiLC8AfJQU8 svg,
  .ljGKLDmJ4fE0Ci6ZG4ez svg {
    margin-right: 12px;
  }
}
.PtD3LPT6aWiLC8AfJQU8:hover, .PtD3LPT6aWiLC8AfJQU8.paomKt1Wes4OfFNmBvEq,
.ljGKLDmJ4fE0Ci6ZG4ez:hover,
.ljGKLDmJ4fE0Ci6ZG4ez.paomKt1Wes4OfFNmBvEq {
  color: #1A1D1F;
}
.PtD3LPT6aWiLC8AfJQU8:hover svg, .PtD3LPT6aWiLC8AfJQU8.paomKt1Wes4OfFNmBvEq svg,
.ljGKLDmJ4fE0Ci6ZG4ez:hover svg,
.ljGKLDmJ4fE0Ci6ZG4ez.paomKt1Wes4OfFNmBvEq svg {
  fill: #1A1D1F;
}
.dark-mode .PtD3LPT6aWiLC8AfJQU8:hover, .dark-mode .PtD3LPT6aWiLC8AfJQU8.paomKt1Wes4OfFNmBvEq,
.dark-mode .ljGKLDmJ4fE0Ci6ZG4ez:hover,
.dark-mode .ljGKLDmJ4fE0Ci6ZG4ez.paomKt1Wes4OfFNmBvEq {
  color: #FCFCFC;
}
.dark-mode .PtD3LPT6aWiLC8AfJQU8:hover svg, .dark-mode .PtD3LPT6aWiLC8AfJQU8.paomKt1Wes4OfFNmBvEq svg,
.dark-mode .ljGKLDmJ4fE0Ci6ZG4ez:hover svg,
.dark-mode .ljGKLDmJ4fE0Ci6ZG4ez.paomKt1Wes4OfFNmBvEq svg {
  fill: #FCFCFC;
}

.PtD3LPT6aWiLC8AfJQU8.paomKt1Wes4OfFNmBvEq,
.ljGKLDmJ4fE0Ci6ZG4ez.paomKt1Wes4OfFNmBvEq {
  background: #EFEFEF;
  box-shadow: inset 0px -2px 1px rgba(0, 0, 0, 0.05), inset 0px 1px 1px #FFFFFF;
}
.dark-mode .PtD3LPT6aWiLC8AfJQU8.paomKt1Wes4OfFNmBvEq,
.dark-mode .ljGKLDmJ4fE0Ci6ZG4ez.paomKt1Wes4OfFNmBvEq {
  background: #272B30;
  box-shadow: inset 0px -2px 1px rgba(0, 0, 0, 0.4), inset 0px 1px 1px rgba(255, 255, 255, 0.11);
}

.gTZwnp_mAGASy0V65rSZ {
  display: none;
  width: 48px;
  height: 48px;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
@media only screen and (max-width: 1259px) {
  .gTZwnp_mAGASy0V65rSZ {
    display: inline-block;
  }
}
@media only screen and (max-width: 767px) {
  .gTZwnp_mAGASy0V65rSZ {
    display: none;
  }
}
.gTZwnp_mAGASy0V65rSZ svg {
  fill: #6F767E;
}
.gTZwnp_mAGASy0V65rSZ svg:nth-child(2) {
  display: none;
}

.tYGO3qjTFYu3lmXlyHqQ {
  display: none;
}
@media only screen and (max-width: 767px) {
  .tYGO3qjTFYu3lmXlyHqQ {
    display: block;
    position: absolute;
    top: 16px;
    left: 16px;
    width: 48px;
    height: 48px;
  }
  .tYGO3qjTFYu3lmXlyHqQ svg {
    fill: #1A1D1F;
  }
  .dark-mode .tYGO3qjTFYu3lmXlyHqQ svg {
    fill: #FCFCFC;
  }
}

.WfuTBXyIoEahukjgLroA {
  margin-top: 24px;
  padding-top: 18px;
  border-top: 2px solid #F4F4F4;
}
@media only screen and (max-width: 1259px) {
  .WfuTBXyIoEahukjgLroA {
    margin-top: 12px;
    padding-top: 12px;
    min-width: 48px;
  }
}
.dark-mode .WfuTBXyIoEahukjgLroA {
  border-color: #272B30;
}

.GNra3OxbEPvdMpfZHC7w {
  margin-top: 16px;
}

.ga1Zt896pLUjR0BQdrJw {
  flex-shrink: 0;
  min-width: 24px;
  margin-left: auto;
  border-radius: 6px;
  background: #CABDFF;
  text-align: center;
  line-height: 24px;
  color: #1A1D1F;
}
@media only screen and (max-width: 1259px) {
  .ga1Zt896pLUjR0BQdrJw {
    display: none;
  }
}
@media only screen and (max-width: 767px) {
  .ga1Zt896pLUjR0BQdrJw {
    display: block;
  }
}

@media only screen and (max-width: 1259px) {
  .VbRh_g0b0O3_rmVRGpui {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 12;
    background: rgba(244, 244, 244, 0.8);
    visibility: hidden;
    opacity: 0;
    transition: all 0.2s;
  }
  .dark-mode .VbRh_g0b0O3_rmVRGpui {
    background: rgba(39, 43, 48, 0.9);
  }
  .VbRh_g0b0O3_rmVRGpui.paomKt1Wes4OfFNmBvEq {
    visibility: visible;
    opacity: 1;
  }
}
@media only screen and (max-width: 767px) {
  .VbRh_g0b0O3_rmVRGpui {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Sidebar/Sidebar.module.sass","webpack://./src/styles/helpers.sass"],"names":[],"mappings":"AAEA;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,mBC8BC;ED7BD,cAAA;EACA,iCAAA;EACA,wBAAA;EACA,qBAAA;AADJ;AAEI;EACI,aAAA;AAAR;ACVI;EDLJ;IAiBQ,YAAA;IACA,aAAA;EAEN;AACF;ACbI;EDRJ;IAoBQ,WAAA;IACA,WAAA;IACA,mBAAA;EAKN;AACF;ACdI;EDdJ;IAwBQ,WAAA;IACA,oBAAA;EAQN;AACF;ACwJa;ED/JL,mBCkBH;ADRL;;AC7BI;EDoBA;IAEQ,oBAAA;IACA,YAAA;IACA,6CAAA;EAYV;EAXU;;IAEI,WAAA;IACA,eAAA;EAad;EAZc;;IACI,kBAAA;EAelB;EAdU;IACI,cAAA;EAgBd;EAfU;IACI,kBAAA;IACA,SAAA;IACA,WAAA;EAiBd;EAhBc;IACI,aCDf;EDmBH;EAjBkB;IACI,aAAA;EAmBtB;EAlBkB;IACI,qBAAA;EAoBtB;AACF;ACzDI;EDcA;IAwBQ,WAAA;EAuBV;AACF;;AAtBA;EACI,cAAA;EACA,WAAA;EACA,mBAAA;AAyBJ;AC7EI;EDiDJ;IAKQ,mBAAA;EA2BN;AACF;ACzEI;EDwCJ;IAOQ,iBAAA;EA8BN;AACF;AA9BI;EACI,WAAA;AAgCR;;AA9BA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;AAiCJ;;AA/BA;;EAEI,kBAAA;AAkCJ;;AAhCA;;EAEI,aAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cC3CC;ED4CD,6CAAA;EACA,wDAAA;AAmCJ;AClHI;EDkEJ;;IAeQ,WAAA;IACA,YAAA;EAsCN;AACF;ACnHI;ED4DJ;;IAkBQ,WAAA;IACA,eAAA;EA0CN;AACF;AA1CI;;EACI,kBAAA;EACA,aCtDH;EDuDG,qBAAA;AA6CR;ACtII;EDsFA;;IAKQ,eAAA;EAgDV;AACF;ACtII;EDgFA;;IAOQ,kBAAA;EAoDV;AACF;AApDI;;;EAEI,cC3DH;ADkHL;AAtDQ;;;EACI,aC7DP;ADuHL;ACsBa;;;ED9ED,cCrEP;ADkIL;AA5DY;;;EACI,aCvEX;ADuIL;;AA/DI;;EACI,mBCvEH;EDwEG,6EAAA;AAmER;ACMa;;EDvED,mBCvEP;EDwEO,8FAAA;AAqEZ;;AAnEA;EACI,aAAA;EACA,WAAA;EACA,YAAA;EACA,6CAAA;AAsEJ;ACxLI;ED8GJ;IAMQ,qBAAA;EAwEN;AACF;ACvLI;EDwGJ;IAQQ,aAAA;EA2EN;AACF;AA3EI;EACI,aCtFH;ADmKL;AA5EQ;EACI,aAAA;AA8EZ;;AA5EA;EACI,aAAA;AA+EJ;ACtMI;EDsHJ;IAGQ,cAAA;IACA,kBAAA;IACA,SAAA;IACA,UAAA;IACA,WAAA;IACA,YAAA;EAiFN;EAhFM;IACI,aCjGP;EDmLH;ECtCW;ID1CG,aCzGX;ED4LH;AACF;;AAlFA;EACI,gBAAA;EACA,iBAAA;EACA,6BAAA;AAqFJ;AClOI;ED0IJ;IAKQ,gBAAA;IACA,iBAAA;IACA,eAAA;EAuFN;AACF;ACvDa;ED/BL,qBC/GH;ADwML;;AAvFA;EACI,gBAAA;AA0FJ;;AAxFA;EACI,cAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBCpIC;EDqID,kBAAA;EACA,iBAAA;EACA,cC3HC;ADsNL;AC3PI;EDwJJ;IAUQ,aAAA;EA6FN;AACF;AC1PI;EDkJJ;IAYQ,cAAA;EAgGN;AACF;;ACrQI;EDsKJ;IAEQ,eAAA;IACA,MAAA;IACA,OAAA;IACA,QAAA;IACA,SAAA;IACA,WAAA;IACA,oCAAA;IACA,kBAAA;IACA,UAAA;IACA,oBAAA;EAkGN;ECjGW;IDCD,iCAAA;EAmGV;EAlGM;IACI,mBAAA;IACA,UAAA;EAoGV;AACF;ACrRI;EDgKJ;IAkBQ,aAAA;EAuGN;AACF","sourcesContent":["@import ../../styles/helpers\n\n.sidebar\n    position: fixed\n    top: 0\n    left: 0\n    bottom: 0\n    display: flex\n    flex-direction: column\n    width: 340px\n    padding: 24px\n    background: $n1\n    overflow: auto\n    -webkit-overflow-scrolling: touch\n    -ms-overflow-style: none\n    scrollbar-width: none\n    &::-webkit-scrollbar\n        display: none \n    +x\n        width: 300px\n        padding: 16px\n    +d\n        z-index: 14\n        width: 96px\n        align-items: center\n    +m\n        width: 100%\n        align-items: stretch\n    +dark\n        background: $n7\n    &.active\n        +d\n            align-items: stretch\n            width: 300px\n            box-shadow: 4px 0 32px rgba($n8, .05)\n            .item,\n            .link\n                width: 100%\n                font-size: 15px\n                svg\n                    margin-right: 12px\n            .counter\n                display: block\n            .toggle\n                position: absolute\n                top: 16px \n                right: 16px\n                svg\n                    fill: $n7\n                    &:first-child\n                        display: none\n                    &:nth-child(2)\n                        display: inline-block\n        +m\n            width: 100%\n\n.logo\n    display: block\n    width: 48px\n    margin-bottom: 48px\n    +x\n        margin-bottom: 24px\n    +m\n        margin-left: auto\n    img\n        width: 100%\n\n.menu\n    display: flex\n    flex-direction: column\n    margin-bottom: auto\n\n.item,\n.dropdown\n    margin-bottom: 8px\n\n.item,\n.link\n    display: flex\n    align-items: center\n    width: 100%\n    height: 48px\n    padding: 0 12px\n    border-radius: 12px\n    font-size: 15px\n    font-weight: 600\n    white-space: nowrap\n    color: $n4\n    -webkit-tap-highlight-color: rgba(0,0,0,0)\n    transition: background .2s, box-shadow .2s, color .2s\n    +d\n        width: 48px\n        font-size: 0\n    +m\n        width: 100%\n        font-size: 15px\n    svg\n        margin-right: 12px\n        fill: $n4\n        transition: fill .2s\n        +d\n            margin-right: 0\n        +m\n            margin-right: 12px\n    &:hover,\n    &.active\n        color: $n7\n        svg\n            fill: $n7\n        +dark\n            color: $n1\n            svg\n                fill: $n1\n    &.active\n        background: $n3\n        box-shadow: inset 0px -2px 1px rgba(0, 0, 0, 0.05), inset 0px 1px 1px #FFFFFF\n        +dark\n            background: $n6\n            box-shadow: inset 0px -2px 1px rgba(0, 0, 0, 0.4), inset 0px 1px 1px rgba(255, 255, 255, 0.11)\n\n.toggle\n    display: none\n    width: 48px\n    height: 48px\n    -webkit-tap-highlight-color: rgba(0,0,0,0)\n    +d\n        display: inline-block\n    +m\n        display: none\n    svg\n        fill: $n4\n        &:nth-child(2)\n            display: none\n\n.close\n    display: none\n    +m\n        display: block\n        position: absolute\n        top: 16px\n        left: 16px\n        width: 48px\n        height: 48px\n        svg\n            fill: $n7\n            +dark\n                fill: $n1\n\n.foot\n    margin-top: 24px\n    padding-top: 18px\n    border-top: 2px solid $n2\n    +d\n        margin-top: 12px\n        padding-top: 12px\n        min-width: 48px\n    +dark\n        border-color: $n6\n\n.theme\n    margin-top: 16px\n\n.counter\n    flex-shrink: 0\n    min-width: 24px\n    margin-left: auto\n    border-radius: 6px\n    background: $s2\n    text-align: center\n    line-height: 24px\n    color: $n7\n    +d\n        display: none\n    +m\n        display: block\n\n.overlay\n    +d\n        position: fixed\n        top: 0\n        left: 0\n        right: 0\n        bottom: 0\n        z-index: 12\n        background: rgba($n2, .8)\n        visibility: hidden\n        opacity: 0\n        transition: all .2s\n        +dark\n            background: rgba($n6, .9)\n        &.active\n            visibility: visible\n            opacity: 1\n    +m\n        display: none","@use \"sass:math\"\n\n// media queries\n=w\n    @media only screen and (max-width: \"1419px\")\n        @content\n=x\n    @media only screen and (max-width: \"1339px\")\n        @content\n=d\n    @media only screen and (max-width: \"1259px\")\n        @content\n=t\n    @media only screen and (max-width: \"1023px\")\n        @content\n=m\n    @media only screen and (max-width: \"767px\")\n        @content\n=a\n    @media only screen and (max-width: \"639px\")\n        @content\n=s\n    @media only screen and (max-width: \"474px\")\n        @content\n\n// fonts\n=inter\n    font-family: 'Inter', sans-serif\n\n// colors\n$p1: #2A85FF\n$p2: #83BF6E\n$p3: #FF6A55\n$p4: #8E59FF\n$s1: #FFBC99\n$s2: #CABDFF\n$s3: #B1E5FC\n$s4: #B5E4CA\n$s5: #FFD88D\n\n$n: #FFFFFF\n$n1: #FCFCFC\n$n2: #F4F4F4\n$n3: #EFEFEF\n$n4: #6F767E\n$n5: #33383F\n$n6: #272B30\n$n7: #1A1D1F\n$n8: #111315\n\n$shades1: #9A9FA5\n$shades2: #6F767E\n$shades3: rgba(#6F767E, .4)\n$shades4: rgba(#111315, .5)\n\n// typography\n=title1-s\n    font-size: 20px\n    font-weight: 600\n    line-height: math.div( 32 , 20 )\n    letter-spacing: -.02em\n    +m\n        font-size: 18px\n\n=title1-m\n    font-size: 20px\n    font-weight: 500\n    line-height: math.div(32,20)\n    letter-spacing: -.02em\n    +m\n        font-size: 18px\n\n=title2\n    font-size: 18px\n    line-height: math.div(24,18)\n    letter-spacing: -0.02em\n\n=base1-s\n    font-size: 15px\n    font-weight: 600\n    line-height: math.div(24,15)\n\n=base1-b\n    font-size: 15px\n    font-weight: 700\n    line-height: math.div(24,15)\n\n=base2\n    font-size: 14px\n    font-weight: 600\n    line-height: math.div(24,14)\n\n=body1-m\n    font-size: 15px\n    font-weight: 500\n    line-height: math.div(24,15)\n    letter-spacing: -.015em\n\n=body1-s\n    font-size: 15px\n    font-weight: 600\n    line-height: math.div(24,15)\n    letter-spacing: -.015em\n\n=body2-s\n    font-size: 14px\n    font-weight: 600\n    line-height: math.div(24,14)\n\n=caption1\n    font-size: 13px\n    font-weight: 600\n    line-height: math.div(16,13)\n\n=caption1-m\n    font-size: 13px\n    font-weight: 500\n    line-height: math.div(16,13)\n\n=caption2\n    font-size: 12px\n    font-weight: 700\n    line-height: math.div(16,12)\n\n=caption2-m\n    font-size: 12px\n    font-weight: 500\n    line-height: 1\n\n=button1\n    font-size: 15px\n    font-weight: 700\n    line-height: math.div(24,15)\n\n=button2\n    font-size: 13px\n    font-weight: 700\n    line-height: math.div(24,13)\n    \n//triangle\n=arr($width, $height, $bg, $direction)\n    width: 0px\n    height: 0px\n    border-style: solid\n    @if $direction == t\n        border-width: 0 $width / 2 + px $height + px $width / 2 + px\n        border-color: transparent transparent $bg transparent\n    @if $direction == r\n        border-width: $height / 2 + px 0 $height / 2 + px $width + px\n        border-color: transparent transparent transparent $bg\n    @if $direction == b\n        border-width: $height + px $width / 2 + px 0 $width / 2 + px\n        border-color: $bg transparent transparent transparent\n    @if $direction == l\n        border-width: $height / 2 + px $width + px $height / 2 + px 0\n        border-color: transparent $bg transparent transparent\n    @if $direction == tl\n        border-width: $height + px $width + px 0 0\n        border-color: $bg transparent transparent transparent\n    @if $direction == tr\n        border-width: 0 $width + px $height + px 0\n        border-color: transparent $bg transparent transparent\n    @if $direction == br\n        border-width: 0 0 $height + px $width + px\n        border-color: transparent transparent $bg transparent\n    @if $direction == bl\n        border-width: $width + px 0 0 $height + px\n        border-color: transparent transparent transparent $bg\n// example\n// +arr(500,50, #000, l)\n// +arr(500,50, #000, bl)\n\n// placeholder\n=placeholder\n    &::placeholder\n        @content\n\n// media query width\n=r($width)\n    @media only screen and (max-width: $width+ \"px\")\n        @content\n\n=rmin($width)\n    @media only screen and (min-width: $width+ \"px\")\n        @content\n\n// theme\n=dark\n    @at-root :global(.dark-mode) &\n        @content\n\n=dark-body\n    @at-root .dark-mode\n        @content\n\n=dark-common\n    @at-root .dark-mode &\n        @content"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sidebar": `AIFt7nJWh1ILj4D7iIA1`,
	"active": `paomKt1Wes4OfFNmBvEq`,
	"item": `PtD3LPT6aWiLC8AfJQU8`,
	"link": `ljGKLDmJ4fE0Ci6ZG4ez`,
	"counter": `ga1Zt896pLUjR0BQdrJw`,
	"toggle": `gTZwnp_mAGASy0V65rSZ`,
	"logo": `Z6jXDuvIMbDGSO1NnHQV`,
	"menu": `MLBeAXKj4hfxhRkNxq2P`,
	"dropdown": `gjhxcI3Kt6h1okdIG1Z0`,
	"close": `tYGO3qjTFYu3lmXlyHqQ`,
	"foot": `WfuTBXyIoEahukjgLroA`,
	"theme": `GNra3OxbEPvdMpfZHC7w`,
	"overlay": `VbRh_g0b0O3_rmVRGpui`
};
export default ___CSS_LOADER_EXPORT___;
